import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stateRequestNumberToStringPipe'
})
export class StateRequestNumberToStringPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case 1: return 'En proceso';
      case 2: return 'Devuelto';
      case 3: return 'Aprobado';
      case 5: return 'En proceso manual';
      case 8: return 'Devuelto';
    }
    return value;
  }
}
